import React from 'react';
import { Prompt } from '../../types';
import { Modal } from '../ui';

interface Props {
  prompt: Prompt;
  onClose: () => void;
}

export const PromptViewerModal: React.FC<Props> = ({ prompt, onClose }) => {
  return (
    <Modal isOpen={true} onClose={onClose} title={prompt.name} size="lg">
      <p className="text-gray-600 mb-4">
        {prompt.domain} - v{prompt.version} - {prompt.type}
      </p>

        <div className="grid grid-cols-3 gap-4 mb-4 text-sm">
          <div>
            <span className="text-gray-500">Status:</span>{' '}
            {prompt.is_active ? 'Actif' : prompt.is_deprecated ? 'Deprecated' : 'Inactif'}
          </div>
          <div>
            <span className="text-gray-500">Utilisé dans:</span>{' '}
            {prompt.used_in_runs_count} runs
          </div>
          <div>
            <span className="text-gray-500">Créé par:</span>{' '}
            {prompt.created_by_name || 'N/A'}
          </div>
        </div>

        {prompt.description && (
          <div className="mb-4">
            <h3 className="font-medium mb-1">Description</h3>
            <p className="text-gray-700">{prompt.description}</p>
          </div>
        )}

        <div>
          <h3 className="font-medium mb-2">Contenu</h3>
          <pre className="bg-gray-100 p-4 rounded overflow-x-auto text-sm font-mono whitespace-pre-wrap">
            {prompt.content}
          </pre>
        </div>

        <div className="mt-4 text-sm text-gray-500">
          <p>Créé le: {new Date(prompt.created_at).toLocaleString('fr-CA', {
            timeZone: 'America/Montreal'
          })}</p>
          <p>Modifié le: {new Date(prompt.updated_at).toLocaleString('fr-CA', {
            timeZone: 'America/Montreal'
          })}</p>
        </div>
    </Modal>
  );
};
